import React from "react";
import styled from "@emotion/styled";

import Icon from "shared/components/Icon";

export type CosignStatusBarProps = {
    title?: string;
    description?: string;
    linkText?: string;
    linkUrl?: string;
    onLinkClick?: () => void;
};

const StatusBarContainer = styled.div({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#ECFDF5",
    border: "1px solid #A7F3D0",
    borderRadius: "8px",
    padding: "16px 20px",
    margin: "8px 16px",
    gap: "16px",
});

const ContentWrapper = styled.div({
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    flex: 1,
});

const IconWrapper = styled.div({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#10B981",
    marginTop: "2px",
});

const TextContent = styled.div({
    display: "flex",
    flexDirection: "column",
    gap: "4px",
});

const Title = styled.h4({
    margin: 0,
    fontSize: "14px",
    fontWeight: 600,
    color: "#065F46",
    textTransform: "uppercase",
    letterSpacing: "0.025em",
});

const Description = styled.p({
    margin: 0,
    fontSize: "14px",
    fontWeight: 400,
    color: "#374151",
    lineHeight: 1.5,
});

const LinkWrapper = styled.a({
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "14px",
    fontWeight: 500,
    color: "#2563EB",
    textDecoration: "none",
    whiteSpace: "nowrap",
    cursor: "pointer",
    flexShrink: 0,
    "&:hover": {
        textDecoration: "underline",
    },
});


export const CosignStatusBar: React.FC<CosignStatusBarProps> = ({
    title = "APPLICATION VERIFIED WITH COSIGN GUARANTEE",
    description = "This application has been verified and guaranteed by Cosign. You are protected with 100% rent default coverage for the duration of the lease.",
    linkText = "View Cosign details",
    linkUrl,
    onLinkClick,
}) => {
    const handleLinkClick = (e: React.MouseEvent) => {
        if (onLinkClick) {
            e.preventDefault();
            onLinkClick();
        }
    };

    return (
        <>
        <StatusBarContainer>
            <ContentWrapper>
                <IconWrapper>
                    <Icon.CosignCheckCircleIcon />
                </IconWrapper>
                <TextContent>
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                </TextContent>
            </ContentWrapper>
            {(linkUrl || onLinkClick) && (
                <LinkWrapper
                    href={linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleLinkClick}
                >
                    {linkText} <Icon.ExternalLinkIcon />
                </LinkWrapper>
            )}
        </StatusBarContainer>
        <br/>
        </>
    );
};

export default CosignStatusBar;

